module.exports = __webpack_public_path__ + "img/1516176170.a3ba3dc3.jpg";